import React, { useState } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonCard, IonCardContent } from "@ionic/react";

const shapePatterns = [
    ["circle", "square", "triangle", "circle", "square", "triangle"],  
    ["circle", "circle", "square", "square", "triangle", "triangle"],  
    ["circle", "circle", "square", "circle", "circle", "square"],  
    ["square", "triangle", "circle", "square", "triangle", "circle"],  
    ["triangle", "circle", "triangle", "square", "triangle", "circle"],  
    ["circle", "square", "square", "triangle", "circle", "square"],  
    ["circle", "triangle", "square", "circle", "triangle", "square"],  
    ["hexagon", "square", "hexagon", "triangle", "hexagon", "square"],  
    ["rectangle", "circle", "rectangle", "square", "rectangle", "circle"],  
    ["square", "triangle", "triangle", "square", "triangle", "triangle"],  
    ["hexagon", "rectangle", "triangle", "hexagon", "rectangle", "triangle"],  
    ["circle", "rectangle", "square", "circle", "rectangle", "square"],  
    ["triangle", "triangle", "circle", "triangle", "triangle", "circle"],  
    ["square", "circle", "triangle", "triangle", "square", "circle"],  
    ["hexagon", "circle", "hexagon", "square", "hexagon", "circle"],  
    ["circle", "triangle", "square", "circle", "triangle", "square"],  
    ["triangle", "square", "triangle", "circle", "triangle", "square"],  
    ["square", "square", "circle", "circle", "triangle", "triangle"],  
    ["rectangle", "triangle", "rectangle", "square", "rectangle", "triangle"],  
    ["hexagon", "triangle", "hexagon", "circle", "hexagon", "triangle"],  
] as const;


type ShapeType = "circle" | "square" | "triangle" | "hexagon" | "rectangle";

type PatternType = (ShapeType | "?")[];


const generatePattern = () => {
    const pattern = [...shapePatterns[Math.floor(Math.random() * shapePatterns.length)]] as PatternType;
    const missingIndex = 5; // Always set missingIndex to index 5
    pattern[missingIndex] = "?"; // Replace index 5 with "?"
    const correctAnswer = shapePatterns.find(p => p.slice(0, 5).toString() === pattern.slice(0, 5).toString())?.[5] as ShapeType;
    return { pattern, missingIndex, correctAnswer, choices: generateChoices(correctAnswer) };
};

const generateChoices = (correctAnswer: ShapeType) => {
    const choices = new Set([correctAnswer]);
    while (choices.size < 3) {
        const randomShape: ShapeType = ["circle", "square", "triangle"][Math.floor(Math.random() * 3)] as ShapeType;
        choices.add(randomShape);
    }
    return Array.from(choices).sort(() => Math.random() - 0.5);
};

const Shape = ({ type }: { type: ShapeType | "?" }) => {
    if (type === "?") {
        return <span style={{ margin: "10px", fontSize: "24px" }}>❓</span>;
    }

    const styles: Record<ShapeType, React.CSSProperties> = {
        circle: { borderRadius: "50%", backgroundColor: "blue", display: "inline-block" },
        square: { backgroundColor: "red", display: "inline-block" },
        triangle: {
            width: 0,
            height: 0,
            display: "inline-block"
        },
        rectangle: {
            backgroundColor: "orange",
            display: "inline-block"
        },
        hexagon: {
            backgroundColor: "purple",
            position: "relative",
            display: "inline-block",
        }
    };

    if (type === "hexagon") {
        return (
            <div style={{ display: "inline-block", margin: "5px" }}>
                <div className="hexagon" style={{ ...styles.hexagon, clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)" }}></div>
            </div>
        );
    }

    return <div className={type} style={{ ...styles[type], margin: "5px" }}></div>;
};

const MissingPatternWorksheet: React.FC = () => {
    const [question, setQuestion] = useState(generatePattern());
    const [feedback, setFeedback] = useState("");
    const [showImage, setShowImage] = useState(false);


    document.title = "Mamas Guidance - Class One - Mathematics - Patterns - Choose Missing Pattern"; // Set page title

    const checkAnswer = (answer: ShapeType) => {
        if (answer === question.correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setQuestion(generatePattern());
                setShowImage(false);
                setFeedback('');
            }, 3000);
        } else {
            setFeedback("❌ Try Again!");
        }
    };

    return (
        <>
            {showImage === false ? (
                <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
                    <div className="mt-3">
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {question.pattern.map((shape, index) => (
                                <Shape key={index} type={shape} />
                            ))}
                        </div>
                        <h5 style={{ marginTop: "50px" }}>Choose</h5>
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            {question.choices.map((choice, index) => (
                                <div key={index} onClick={() => checkAnswer(choice)}>
                                    <Shape type={choice} />
                                </div>
                            ))}
                        </div>
                        <h3 style={{ textAlign: "center" }}>{feedback}</h3>
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img style={{ height: "150px" }} className="img-fluid" src={process.env.REACT_APP_WELDONE_LINK} alt="Well Done" />
                </div>
            )}
        </>
    );
};

export default MissingPatternWorksheet;
